import { string } from "@amcharts/amcharts4/core";
import { environment } from "src/environment/environment";

export const BaseURL: string = environment.hmApiURL;

export const HospitalBaseURL: string = BaseURL + '/H';

//#region RevenueReport API
export const RevenueReportURL: string = HospitalBaseURL + '/RR';
export const RevenueReport_Create: string = RevenueReportURL + '/Create';
//#endregion

//#region HospitalMaster API
export const HospitalMasterURL: string = HospitalBaseURL + '/HM';
export const HospitalMaster_Create: string = HospitalMasterURL + '/Create';
export const HospitalMaster_Update:string = HospitalMasterURL + '/Update';
export const HospitalMaster_Delete:string = HospitalMasterURL + '/Delete';
export const HospitalMaster_ReadAll: string = HospitalMasterURL + '/ReadAll';
export const HospitalMaster_ReadById: string = HospitalMasterURL + '/ReadById';
export const HospitalMaster_ExternalReadById: string = HospitalMasterURL + '/ReadById_External';
export const HospitalMaster_ReadAllPaginated: string = HospitalMasterURL + '/ReadAllPaginated';
export const HospitalMaster_OnboardingComplete: string = HospitalMasterURL + '/OnboardingComplete';
export const HospitalMaster_OnboardingReadAllPaginated: string = HospitalMasterURL + '/OnboardingReadAllPaginated';
export const HospitalMaster_GetSummaryByHospital: string = HospitalMasterURL + '/GetSummaryByHospital';
export const HosptialMaster_SmallHospitalDashboardKPI: string = HospitalMasterURL + '/SmallHospitalDashboardKPI';
export const HospitalMaster_ReadByHospitalIdOwner:string = HospitalMasterURL + '/ReadByHospitalIdOwner';   
//#endregion

//#region PatientVisit API
export const PatientVisitURL: string = HospitalBaseURL + '/PV';
export const PatientVisit_Create: string = PatientVisitURL + '/Create';
export const PatientVisit_Update: string = PatientVisitURL + '/Update';
export const PatientVisit_Delete: string = PatientVisitURL + '/Delete';
export const PatientVisit_ReadAll: string = PatientVisitURL + '/ReadAll';
export const PatientVisit_ReadById: string = PatientVisitURL + '/ReadById';
export const PatientVisit_ReadByHospitalId: string = PatientVisitURL + '/ReadByHospitalId';
export const PatientVisit_ReadByMobileNo: string = PatientVisitURL + '/ReadByMobileNo';
//#endregion

//#region VisitAffiliationMapping API
export const VisitAffiliationMappingURL: string = HospitalBaseURL + '/VAM';
export const VisitAffiliationMapping_Create: string = VisitAffiliationMappingURL + '/Create';
export const VisitAffiliationMapping_Update: string = VisitAffiliationMappingURL + '/Update';
export const VisitAffiliationMapping_Delete: string = VisitAffiliationMappingURL + '/Delete';
export const VisitAffiliationMapping_ReadById: string = VisitAffiliationMappingURL + '/ReadById';
export const VisitAffiliationMapping_ReadAll: string = VisitAffiliationMappingURL + '/ReadAll';

//reagion TreatmentOrder API

export const TreatmentOrderURL :string = HospitalBaseURL + '/TO';
export const TratmentOrder_Create : string = TreatmentOrderURL + '/Create';
export const TratmentOrder_Update : string = TreatmentOrderURL + '/Update';
export const TratmentOrder_Delete : string = TreatmentOrderURL + '/Delete';
export const TratmentOrder_ReadaAll : string = TreatmentOrderURL + '/ReadAll';
export const TratmentOrder_ReadById : string = TreatmentOrderURL + '/ReadById';
export const TratmentOrder_ReadByHospitalId : string = TreatmentOrderURL + '/ReadByHospitalId';
export const TratmentOrder_ReadByPatientId : string = TreatmentOrderURL + '/ReadByPatientId';
export const TratmentOrder_ReadByTreatmentId : string = TreatmentOrderURL + '/ReadByTreatmentId';

//#region RoundUpNote API
export const RoundUpNoteURL :string = HospitalBaseURL + '/RUP';
export const RoundUpNote_RealAll :string = RoundUpNoteURL + '/ReadAll';
export const RoundUpNote_Create :string = RoundUpNoteURL + '/Create';
export const RoundUpNote_Update :string = RoundUpNoteURL + '/Update';
export const RoundUpNote_Delete :string = RoundUpNoteURL + '/Delete';
export const RoundUpNote_ReadById :string = RoundUpNoteURL + '/ReadById';
export const RoundUpNote_ReadByPlanId :string = RoundUpNoteURL + '/ReadByPlanId';
export const RoundUpNote_ReadByPatientId :string = RoundUpNoteURL + '/ReadByPatientId';
export const RoundUpNote_ReadByStaffId :string = RoundUpNoteURL + '/ReadByStaffId';
export const RoundUpNote_ReadByHospitalId :string = RoundUpNoteURL + '/ReadByHospitalId';

////#endregion

//#region PrescriptionMaster API
export const PrescriptionMasterURL: string = HospitalBaseURL + '/PPM';
export const PrescriptionMaster_Create: string = PrescriptionMasterURL + '/Create';
export const PrescriptionMaster_Update: string = PrescriptionMasterURL + '/Update';
export const PrescriptionMaster_Delete: string = PrescriptionMasterURL + '/Delete';
export const PrescriptionMaster_ReadById: string = PrescriptionMasterURL + '/ReadById';
export const PrescriptionMaster_CreateBulk: string = PrescriptionMasterURL + '/CreateBulk';
export const PrescriptionMaster_ReadAll: string = PrescriptionMasterURL + '/ReadAll';
export const PrescriptionMaster_ReadyByDoctorId : string = PrescriptionMasterURL + '/ReadByDoctorId';
export const PrescriptionMaster_ReadAllPaginated : string = PrescriptionMasterURL + '/ReadAllPaginated';
export const PrescriptionMaster_GetTotalOPDPatient:string = PrescriptionMasterURL + '/GetTotalOPDPatient';
export const PrescriptionMaster_ReadByVisitId:string = PrescriptionMasterURL + '/ReadByVisitId';
// export const PrescriptionMaster_ReadByUserId:string = PrescriptionMasterURL + '/ReadByUserId';
//#endregion

//region PrescriptionMedication API
export const PrescriptionMedicationURL: string = HospitalBaseURL + '/PMC';
export const PrescriptionMedication_Create: string = PrescriptionMedicationURL + '/Create';
export const PrescriptionMedication_Update: string = PrescriptionMedicationURL + '/Update';
export const PrescriptionMedication_Delete: string = PrescriptionMedicationURL + '/Delete';
export const PrescriptionMedication_ReadById: string = PrescriptionMedicationURL + '/ReadById';
export const PrescriptionMedication_CreateBulk: string = PrescriptionMedicationURL + '/CreateBulk'; 
export const PrescriptionMedication_ReadAll: string = PrescriptionMedicationURL + '/ReadAll';
export const PrescriptionMedication_ReadByPrescriptionId : string = PrescriptionMedicationURL +'/ReadByPrescriptionId';
//#endregion

//reigon TreatmentMedicine API
export const TreatmentMedicineURL: string = HospitalBaseURL + '/TME';
export const TreatmentMedicine_Create: string = TreatmentMedicineURL + '/Create';
export const TreatmentMedicine_CreateBulk: string = TreatmentMedicineURL + '/CreateBulk';
export const TreatmentMedicine_Update: string = TreatmentMedicineURL + '/Update';
export const TreatmentMedicine_Delete: string = TreatmentMedicineURL + '/Delete';
export const TreatmentMedicine_ReadById: string = TreatmentMedicineURL + '/ReadById';
export const TreatmentMedicine_ReadByHospitalId: string = TreatmentMedicineURL + '/ReadByHospitalId';
export const TreatmentMedicine_ReadByTreatmentId: string = TreatmentMedicineURL + '/ReadByTreatmentId';
export const TreatmentMedicine_ReadByPatientId: string = TreatmentMedicineURL + '/ReadByPatientId';
//#endregion

//region VisitComplaint API
export const VisitComplaintURL: string = HospitalBaseURL + '/VC';
export const VisitComplaint_Create: string = VisitComplaintURL + '/Create';
export const VisitComplaint_Update: string = VisitComplaintURL + '/Update';
export const VisitComplaint_Delete: string = VisitComplaintURL + '/Delete';
export const VisitComplaint_ReadById: string = VisitComplaintURL + '/ReadById';
export const VisitComplaint_ReadByPrescriptionId: string = VisitComplaintURL + '/ReadByPrescriptionId';
export const VisitComaplaint_CreateBulk: string = VisitComplaintURL + '/CreateBulk';
//#endregion

//region PrescriptionDiagnosis API
export const PrescriptionDiagnosisURL: string = HospitalBaseURL + '/PD';
export const PrescriptionDiagnosis_Create: string = PrescriptionDiagnosisURL + '/Create';
export const PrescriptionDiagnosis_Update: string = PrescriptionDiagnosisURL + '/Update';
export const PrescriptionDiagnosis_Delete: string = PrescriptionDiagnosisURL + '/Delete';
export const PrescriptionDiagnosis_ReadById: string = PrescriptionDiagnosisURL + '/ReadById';
export const PrescriptionDiagnosis_CreateBulk: string = PrescriptionDiagnosisURL + '/CreateBulk';
export const PrescriptionDiagnosis_ReadAll :string = PrescriptionDiagnosisURL + '/ReadAll';
export const PrescriptionDiagnosis_ReadByPrescriptionId :string = PrescriptionDiagnosisURL + '/ReadByPrescriptionId'
//endregion

//#region DoctorComponentMaster API
// export const DoctorComponentMasterURL: string = HospitalBaseURL + '/DM';
// export const DoctorComponentMaster_Create: string  = DoctorComponentMasterURL + '/Create';
// export const DoctorComponentMaster_Update: string = DoctorComponentMasterURL + '/Update';
// export const DoctorComponentMaster_Delete: string = DoctorComponentMasterURL + '/Delete';
// export const DoctorComponentMaster_ReadAll: string = DoctorComponentMasterURL + '/ReadAll';
// export const DoctorComponentMaster_ReadById: string = DoctorComponentMasterURL + '/ReadById';
// export const DoctorComponentMaster_ReadByHospitalId: string = DoctorComponentMasterURL + '/ReadByHospitalId';
// export const DoctorComponentMaster_ReadAllPaginated: string = DoctorComponentMasterURL + '/ReadAllPaginated';
//#endregion

//#region ServiceComponentMaster API
export const ServiceComponentMasterURL: string = HospitalBaseURL + '/SM';
export const ServiceComponentMaster_Create: string = ServiceComponentMasterURL + '/Create';
export const ServiceComponentMaster_Update: string = ServiceComponentMasterURL + '/Update';
export const ServiceComponentMaster_Delete: string = ServiceComponentMasterURL + '/Delete';
export const ServiceComponentMaster_ReadAll: string = ServiceComponentMasterURL + '/ReadAll';
export const ServiceComponentMaster_ReadById: string = ServiceComponentMasterURL + '/ReadById';
export const ServiceComponentMaster_ReadByHospitalId: string = ServiceComponentMasterURL + '/ReadByHospitalId';
export const ServiceComponentMaster_ReadAllPaginated: string = ServiceComponentMasterURL + '/ReadAllPaginated';
//#endregion

//#region HospitalImgMaster API
export const HospitalImgMasterURL: string = HospitalBaseURL + '/HIM';
export const HospitalImgMaster_Create: string = HospitalImgMasterURL + '/Create';
export const HospitalImgMaster_Update: string = HospitalImgMasterURL + '/Update';
export const HospitalImgMaster_Delete: string = HospitalImgMasterURL + '/Delete';
export const HospitalImgMaster_ReadAll: string = HospitalImgMasterURL + '/ReadAll';
export const HospitalImgMaster_ReadById: string = HospitalImgMasterURL + '/ReadById';
export const HospitalImgMaster_ReadByMasterId: string = HospitalImgMasterURL + '/ReadByMasterId';
export const HospitalImgMaster_ReadByMasterType: string = HospitalImgMasterURL + '/ReadByMasterType';
//#endregion

//#region HospitalDocMaster API
export const HospitalDocMasterURL: string = HospitalBaseURL + '/HDM';
export const HospitalDocMaster_Create: string = HospitalDocMasterURL + '/Create';
export const HospitalDocMaster_Update: string = HospitalDocMasterURL + '/Update';
export const HospitalDocMaster_Delete: string = HospitalDocMasterURL + '/Delete';
export const HospitalDocMaster_ReadAll: string = HospitalDocMasterURL + '/ReadAll';
export const HospitalDocMaster_ReadById: string = HospitalDocMasterURL + '/ReadById';
export const HospitalDocMaster_ReadByMasterId: string = HospitalDocMasterURL + '/ReadByMasterId';
export const HospitalDocMaster_ExternalReadByMasterId: string = HospitalDocMasterURL + '/ReadByMasterId_External';
export const HospitalDocMaster_CreateBulk: string = HospitalDocMasterURL + '/CreateBulk';
export const HospitalDocMaster_ExternalCreateBulk: string = HospitalDocMasterURL + '/CreateBulk_External';
//#endregion

//#region HospitalInvoiceMaster API
export const HospitalInvoiceMasterURL: string = HospitalBaseURL + '/IM';
export const HospitalInvoiceMaster_Create: string = HospitalInvoiceMasterURL + '/Create';
export const HospitalInvoiceMaster_Update: string = HospitalInvoiceMasterURL + '/Update';
export const HospitalInvoiceMaster_Delete: string = HospitalInvoiceMasterURL + '/Delete';
// export const HospitalInvoiceMaster_ReadAll: string = HospitalInvoiceMasterURL + '/ReadAll';
export const HospitalInvoiceMaster_ReadById: string = HospitalInvoiceMasterURL + '/ReadById';
export const HospitalInvoiceMaster_ReadByUserId: string = HospitalInvoiceMasterURL + '/ReadByUserId';
export const HospitalInvoiceMaster_ReadByHospitalId: string = HospitalInvoiceMasterURL + '/ReadByHospitalId';
export const HospitalInvoiceMaster_ReadAllPaginated: string = HospitalInvoiceMasterURL + '/ReadAllPaginated';
// export const HospitalInvoiceMaster_HTMLGenerate: string = HospitalInvoiceMasterURL + '/HTMLGenerate';
export const HospitalInvoiceMaster_InvoiceMasterOwnerDashboardRead:string = HospitalInvoiceMasterURL + '/OwnerDashboardRead'
//#endregion

//#region HospitalInvoiceDetail API
export const HospitalInvoiceDetailURL: string = HospitalBaseURL + '/ID';
export const HospitalInvoiceDetail_Create: string = HospitalInvoiceDetailURL + '/Create';
export const HosptialInvoiceDetail_Update: string = HospitalInvoiceDetailURL + '/Update';
export const HospitalInvoiceDetail_Delete: string = HospitalInvoiceDetailURL + '/Delete';
export const HospitalInvoiceDetail_ReadAll: string = HospitalInvoiceDetailURL + '/ReadAll';
export const HospitalInvoiceDetail_ReadById: string = HospitalInvoiceDetailURL + '/ReadById';
export const HospitalInvoiceDetail_ReadByInvoiceId: string = HospitalInvoiceDetailURL + '/ReadInvoiceId';
export const HospitalInvoiceDetail_ReadByServiceId: string = HospitalInvoiceDetailURL + '/ReadByServiceId';
export const HospitalInvoiceDetail_ReadByPatientId: string = HospitalInvoiceDetailURL + '/ReadByUserId';
export const HospitalInvoiceDetail_CreateBulk:string=HospitalInvoiceDetailURL+'/CreateBulk'
//#endregion

//#region HospitalUserMapping API
export const HospitalUserAffiliationURL: string = HospitalBaseURL + '/UAM';
export const HospitalUserAffiliation_Create: string = HospitalUserAffiliationURL + '/Create';
export const HospitalUserAffiliation_Create_External: string = HospitalUserAffiliationURL + '/Create_External';
export const HospitalUserAffiliation_Update: string = HospitalUserAffiliationURL + '/Update';
export const HospitalUserAffiliation_UpdateExternal: string = HospitalUserAffiliationURL + '/Update_Extrenal';
export const HospitalUserAffiliation_Delete: string = HospitalUserAffiliationURL + '/Delete';
export const HospitalUserAffiliation_ReadAll: string = HospitalUserAffiliationURL + '/ReadAll';
export const HospitalUserAffiliation_ReadById: string = HospitalUserAffiliationURL + '/ReadById';
export const HospitalUserAffiliation_ReadByIdExternal: string = HospitalUserAffiliationURL + '/ReadById_External';
export const HospitalUserAffiliation_ReadByHospitalId: string = HospitalUserAffiliationURL + '/ReadByHospitalId';
export const HospitalUserAffiliation_ReadByUserId: string = HospitalUserAffiliationURL + '/ReadByUserId';
export const HospitalUserAffiliation_DoctorGetDictonary: string = HospitalUserAffiliationURL + '/DoctorGetDictionary';
export const HosptialUserAffiliation_ReadUserByHospitalId: string = HospitalUserAffiliationURL + '/ReadUserByHospitalId';
export const HosptialUserAffiliation_ReadUserBySearchTerm: string = HospitalUserAffiliationURL + '/ReadUserBySearchTerm';
export const HosptialUserAffiliation_HospitalDashboardKPI: string = HospitalUserAffiliationURL + '/HospitalDashboardKPI'
export const HosptialUserAffiliation_ReadAllPaginated: string = HospitalUserAffiliationURL + '/ReadAllPaginated'
export const HospitalUserAffiliation_TotalStaff: string = HospitalUserAffiliationURL + '/TotalStaff';
//#endregion

//#region AppointmentScheduleMaster API
export const AppointmentScheduleMasterURL: string = HospitalBaseURL + '/ASM';
export const AppointmentScheduleMaster_Create: string = AppointmentScheduleMasterURL + '/Create';
export const AppointmentScheduleMaster_Update: string = AppointmentScheduleMasterURL + '/Update';
export const AppointmentScheduleMaster_Delete: string = AppointmentScheduleMasterURL + '/Delete';
export const AppointmentScheduleMaster_ReadAll: string = AppointmentScheduleMasterURL + '/ReadAll';
export const AppointmentScheduleMaster_ReadById: string = AppointmentScheduleMasterURL + '/ReadById';
export const AppointmentScheduleMaster_ReadByHospitalId: string = AppointmentScheduleMasterURL + '/ReadByHospitalId';
export const AppointmentScheduleMaster_ReadByPatientId: string = AppointmentScheduleMasterURL + '/ReadByPatientId';
export const AppointmentScheduleMaster_ReadByDoctorId: string = AppointmentScheduleMasterURL + '/ReadByDoctorId';
export const AppointmentScheduleMaster_ReadByServiceId: string = AppointmentScheduleMasterURL + '/ReadByServiceId';
export const AppointmentScheduleMaster_GetDoctorAppointments: string = AppointmentScheduleMasterURL + '/GetDoctorAppointments';
export const AppointmentScheduleMaster_GetAppointmentByDate: string = AppointmentScheduleMasterURL + '/GetAppointmentsByDate';
export const AppointmentScheduleMaster_DoctorDailyAppointment: string = AppointmentScheduleMasterURL + '/DoctorDailyAppointment';
export const AppointmentScheduleMaster_DoctorPatientPerWeekOrYear: string = AppointmentScheduleMasterURL + '/DoctorPatientPerWeekOrYear';
export const AppointmentScheduleMaster_WeeklyVisits: string = AppointmentScheduleMasterURL + '/WeeklyVisits';
export const AppointmentScheduleMaster_HospitalWeeklyOrYearlyAppointment: string = AppointmentScheduleMasterURL + '/HospitalWeeklyOrYearlyAppointment';
export const AppointmentScheduleMaster_HospitalPatientPerWeek: string = AppointmentScheduleMasterURL + '/HospitalPatientPerWeek';
export const AppointmentScheduleMaster_ReadPendingAppointmentByMaster: string = AppointmentScheduleMasterURL + '/ReadPendingAppointmentByMaster';
export const AppointmentScheduleMaster_ReadAllPaginated: string = AppointmentScheduleMasterURL + '/ReadAllPaginated';
//#endregion

//#region AppointmentMaster API 
export const AppointmentMasterURL: string = HospitalBaseURL + '/AM';
export const AppointmentMaster_Create: string = AppointmentMasterURL + '/Create';
export const AppointmentMaster_Update: string = AppointmentMasterURL + '/Update';
export const AppointmentMaster_Delete: string = AppointmentMasterURL + '/Delete';
export const AppointmentMaster_ReadAll: string = AppointmentMasterURL + '/ReadAll';
export const AppointmentMaster_ReadById: string = AppointmentMasterURL + '/ReadById';
export const AppointmentMaster_ReadByMasterId: string = AppointmentMasterURL + '/ReadByMasterId';
export const AppointmentMaster_GetDoctorTimeTable: string = AppointmentMasterURL + '/GetDoctorTimeTable';
//#endregion

//#region AppointmentDetail API
export const AppointmentDetailURL: string = HospitalBaseURL + '/AD';
export const AppointmentDetail_Create: string = AppointmentDetailURL + '/Create';
export const AppointmentDetail_Update: string = AppointmentDetailURL + '/Update';
export const AppointmentDetail_Delete: string = AppointmentDetailURL + '/Delete';
export const AppointmentDetail_ReadAll: string = AppointmentDetailURL + '/ReadAll';
export const AppointmentDetail_ReadById: string = AppointmentDetailURL + '/ReadById';
export const AppointmentDetail_ReadByAppointmentId: string = AppointmentDetailURL + '/ReadByAppointmentId';
//#endregion

//#region HospitalWingMaster API
export const HospitalWingMasterURL: string = HospitalBaseURL + '/HWM';
export const HospitalWingMaster_Create: string = HospitalWingMasterURL + '/Create';
export const HospitalWingMaster_Update: string = HospitalWingMasterURL + '/Update';
export const HospitalWingMaster_Delete: string = HospitalWingMasterURL + '/Delete';
export const HospitalWingMaster_ReadAll: string = HospitalWingMasterURL + '/ReadAll';
export const HospitalWingMaster_ReadById: string = HospitalWingMasterURL + '/ReadById';
export const HospitalWingMaster_ReadByHospitalId: string = HospitalWingMasterURL + '/ReadByHospitalId';
export const HospitalWingMaster_CreateBulk: string = HospitalWingMasterURL + '/CreateBulk';
//#endregion

//#region HospitalWardMaster API
export const HospitalWardMasterURL: string = HospitalBaseURL + '/WARD';
export const HospitalWardMaster_Create: string = HospitalWardMasterURL + '/Create';
export const HospitalWardMaster_Update: string = HospitalWardMasterURL + '/Update';
export const HospitalWardMaster_Delete: string = HospitalWardMasterURL + '/Delete';
export const HospitalWardMaster_ReadAll: string = HospitalWardMasterURL + '/ReadAll';
export const HospitalWardMaster_ReadById: string = HospitalWardMasterURL + '/ReadById';
export const HospitalWardMaster_ReadByHospitalId: string = HospitalWardMasterURL + '/ReadByHospitalId';
export const HospitalWardMaster_ReadByWingId: string = HospitalWardMasterURL + '/ReadByWingId';
//#endregion

//#region HospitalRoomMaster API
export const HospitalRoomMasterURL: string = HospitalBaseURL + '/HRM';
export const HosptialRoomMaster_Create: string = HospitalRoomMasterURL + '/Create';
export const HospitalRoomMaster_Update: string = HospitalRoomMasterURL + '/Update';
export const HospitalRoomMaster_Delete: string = HospitalRoomMasterURL + '/Delete';
export const HospitalRoomMaster_ReadAll: string = HospitalRoomMasterURL + '/ReadAll';
export const HospitalRoomMaster_ReadById: string = HospitalRoomMasterURL + '/ReadById';
export const HospitalRoomMaster_ReadByHospitalId: string = HospitalRoomMasterURL + '/ReadByHospitalId';
export const HospitalRoomMaster_ReadByWingId: string = HospitalRoomMasterURL + '/ReadByWingId';
export const HospitalRoomMaster_ReadByWardId: string = HospitalRoomMasterURL + '/ReadByWardId';
export const HospitalRoomMaster_PredictNextRoomNumber: string = HospitalRoomMasterURL + '/PredictNextRoomNumber';
//#endregion

//#region HospitalBedMaster API
export const HospitalBedMasterURL: string = HospitalBaseURL + '/HBM';
export const HospitalBedMaster_Create: string = HospitalBedMasterURL + '/Create';
export const HospitalBedMaster_Update: string = HospitalBedMasterURL + '/Update';
export const HospitalBedMaster_Delete: string = HospitalBedMasterURL + '/Delete';
export const HospitalBedMaster_ReadAll: string = HospitalBedMasterURL + '/ReadAll';
export const HospitalBedMaster_ReadById: string = HospitalBedMasterURL + '/ReadById';
export const HospitalBedMaster_ReadByHospitalId: string = HospitalBedMasterURL + '/ReadByHospitalId';
export const HospitalBedMaster_ReadByRoomId: string = HospitalBedMasterURL + '/ReadByRoomId';
export const HospitalBedMaster_ReadByWardId: string = HospitalBedMasterURL + '/ReadByWardId';
export const HospitalBedMaster_PredictNextBedNumber: string = HospitalBedMasterURL + '/PredictNextBedNumber';
export const HospitalBedMaster_ReadOccupancy: string = HospitalBedMasterURL + '/ReadOccupancy';
//#endregion

//#region TreatmentPlanMaster API
export const TreatmentPlanMasterURL: string = HospitalBaseURL + '/TPM';
export const TreatmentPlanMaster_Create: string = TreatmentPlanMasterURL + '/Create';
export const TreatmentPlanMaster_Update: string = TreatmentPlanMasterURL + '/Update';
export const TreatmentPlanMaster_Delete: string = TreatmentPlanMasterURL + '/Delete';
export const TreatmentPlanMaster_ReadAll: string = TreatmentPlanMasterURL + '/ReadAll';
export const TreatmentPlanMaster_ReadAllPaginated: string = TreatmentPlanMasterURL + '/ReadAllPaginated';
export const TreatmentPlanMaster_ReadById: string = TreatmentPlanMasterURL + '/ReadById';
export const TreatmentPlanMaster_ReadByDoctorId: string = TreatmentPlanMasterURL + '/ReadByDoctorId';
export const TreatmentPlanMaster_ReadByPatientId: string = TreatmentPlanMasterURL + '/ReadByPatientId';
export const TreatmentPlanMaster_ReadByHospitalId: string = TreatmentPlanMasterURL + '/ReadByHospitalId';
export const TreatmentPlanMaster_ReadByDoctorIdAndDate : string = TreatmentPlanMasterURL + '/ReadByDoctorIdAndDate';
export const TreatmentPlanMaster_GetDashboardPatientCountsKPI: string = TreatmentPlanMasterURL + '/GetDashboardPatientCountsKPI';
//#endregion

//#region TreatmentPlanDetail API
export const TreatmentPlanDetailURL: string = HospitalBaseURL + '/TPD';
export const TreatmentPlanDetail_Create: string = TreatmentPlanDetailURL + '/Create';
export const TreatmentPlanDetail_Update: string = TreatmentPlanDetailURL + '/Update';
export const TreatmentPlanDetail_Delete: string = TreatmentPlanDetailURL + '/Delete';
export const TreatmentPlanDetail_ReadAll: string = TreatmentPlanDetailURL + '/ReadAll';
export const TreatmentPlanDetail_ReadById: string = TreatmentPlanDetailURL + '/ReadById';
export const TreatmentPlanDetail_ReadByPlanId: string = TreatmentPlanDetailURL + '/ReadByPlanId';
export const TreatmentPlanDetail_ReadByServiceId: string = TreatmentPlanDetailURL + '/ReadByServiceId';
export const TreatmentPlanDetail_CreateBulk: string = TreatmentPlanDetailURL + "/CreateBulk";
//#endregion

//#region OnBoardingPreCheck API
export const HospitalOnBoardingPreCheckURL: string = HospitalBaseURL + '/OBC';
export const HospitalOnBoardingPreCheck_Create: string = HospitalOnBoardingPreCheckURL + '/Create';
export const HospitalOnBoardingPreCheck_Update: string = HospitalOnBoardingPreCheckURL + '/Update';
export const HospitalOnBoardingPreCheck_Delete: string = HospitalOnBoardingPreCheckURL + '/Delete';
export const HospitalOnBoardingPreCheck_ReadAll: string = HospitalOnBoardingPreCheckURL + '/ReadAll';
export const HospitalOnBoardingPreCheck_ReadById: string = HospitalOnBoardingPreCheckURL + '/ReadById';
export const HospitalOnBoardingPreCheck_ReadByHospitalId: string = HospitalOnBoardingPreCheckURL + '/ReadByHospitalId';
//#endregion

//#region PatientReport API
export const HospitalPatientReportURL: string = HospitalBaseURL + '/PR';
export const HospitalPatientReport_Create: string = HospitalPatientReportURL + '/Create';
export const HospitalPatientReport_Update: string = HospitalPatientReportURL + '/Update';
export const HospitalPatientReport_Delete: string = HospitalPatientReportURL + '/Delete';
export const HospitalPatientReport_ReadAll: string = HospitalPatientReportURL + '/ReadAll';
export const HospitalPatientReport_ReadById: string = HospitalPatientReportURL + '/ReadById';
export const HospitalPatientReport_ReadByHospitalId: string = HospitalPatientReportURL + '/ReadByHospitalId';
export const HospitalPatientReport_ReadByDoctorId: string = HospitalPatientReportURL + '/ReadByDoctorId';
export const HospitalPatientReport_ReadByPatientId: string = HospitalPatientReportURL + '/ReadByPatientId';
export const HospitalPatientReport_ReadByBedId: string = HospitalPatientReportURL + '/ReadByBedId';
//#endregion

//#region FeedbackMaster API
export const FeedbackMasterURL: string = HospitalBaseURL + '/FM';
export const FeedbackMaster_Create: string = FeedbackMasterURL + '/Create';
export const FeedbackMaster_Update: string = FeedbackMasterURL + '/Update';
export const FeedbackMaster_Delete: string = FeedbackMasterURL + '/Delete';
export const FeedbackMaster_ReadAll: string = FeedbackMasterURL + '/ReadAll';
export const FeedbackMaster_ReadById: string = FeedbackMasterURL + '/ReadById';
export const FeedbackMaster_ReadByHospitalId: string = FeedbackMasterURL + '/ReadByHospitalId';
export const FeedbackMaster_ReadByMasterId: string = FeedbackMasterURL + '/ReadByMasterId';
//#endregion

//#region FeedbackPatientDischarge API
export const FeedbackPatientDischargeURL: string = HospitalBaseURL + '/FPD';
export const FeedbackPatientDischarge_Create: string = FeedbackPatientDischargeURL + '/Create';
export const FeedbackPatientDischarge_Update: string = FeedbackPatientDischargeURL + '/Update';
export const FeedbackPatientDischarge_Delete: string = FeedbackPatientDischargeURL + '/Delete';
export const FeedbackPatientDischarge_ReadAll: string = FeedbackPatientDischargeURL + '/ReadAll';
export const FeedbackPatientDischarge_ReadByBedId: string = FeedbackPatientDischargeURL + '/ReadByBedId';
export const FeedbackPatientDischarge_ReadByFeedbackId: string = FeedbackPatientDischargeURL + '/ReadByFeedbackId';
export const FeedbackPatientDischarge_ReadById: string = FeedbackPatientDischargeURL + '/ReadById';
export const FeedbackPatientDischarge_ReadByPatientId: string = FeedbackPatientDischargeURL + '/ReadByPatientId';
export const FeedbackPatientDischarge_ReadByRoomId: string = FeedbackPatientDischargeURL + '/ReadByRoomId';
export const FeedbackPatientDischarge_ReadByTreatmentId: string = FeedbackPatientDischargeURL + '/ReadByTreatmentId';
export const FeedbackPatientDischarge_ReadByWardId: string = FeedbackPatientDischargeURL + '/ReadByWardId';
//#endregion

//#region TreatmentTemplateMaster API
export const TreatmentTemplateMasterURL: string = HospitalBaseURL + '/TTM';
export const TreatmentTemplateMaster_Create: string = TreatmentTemplateMasterURL + '/Create';
export const TreatmentTemplateMaster_Update: string = TreatmentTemplateMasterURL + '/Update';   
export const TreatmentTemplateMaster_Delete: string = TreatmentTemplateMasterURL + '/Delete';
export const TreatmentTemplateMaster_ReadAll: string = TreatmentTemplateMasterURL + '/ReadAll';
export const TreatmentTemplateMaster_ReadById: string = TreatmentTemplateMasterURL + '/ReadById';
export const TreatmentTemplateMaster_ReadByHospitalId: string = TreatmentTemplateMasterURL + '/ReadByHospitalId';
export const TreatmentTemplateMaster_ReadAllPaginated: string = TreatmentTemplateMasterURL + '/ReadAllPaginated';
//#endregion

//#region TreatmentTemplateDetail API
export const TreatmentTemplateDetailURL: string = HospitalBaseURL + '/TTD';
export const TreatmentTemplateDetail_Create: string = TreatmentTemplateDetailURL + '/Create';
export const TreatmentTemplateDetail_Update: string = TreatmentTemplateDetailURL + '/Update';
export const TreatmentTemplateDetail_Delete: string = TreatmentTemplateDetailURL + '/Delete';
export const TreatmentTemplateDetail_ReadAll: string = TreatmentTemplateDetailURL + '/ReadAll';
export const TreatmentTemplateDetail_ReadById: string = TreatmentTemplateDetailURL + '/ReadById';
export const TreatmentTemplateDetail_ReadByServiceId: string = TreatmentTemplateDetailURL + '/ReadByServiceId';
export const TreatmentTemplateDetail_ReadBytemplateId: string = TreatmentTemplateDetailURL + '/ReadByTemplateId';
export const TreatmentTemplateDetail_ReadAllPaginated: string = TreatmentTemplateDetailURL + '/ReadAllPaginated';
//#endregion

//#region PrintTemplate API
export const PrintTemplateURL: string = HospitalBaseURL + '/PT';
export const PrintTemplate_Create: string = PrintTemplateURL + '/Create';
export const PrintTemplate_Update: string = PrintTemplateURL + '/Update';
export const PrintTemplate_Delete: string = PrintTemplateURL + '/Delete';
export const PrintTemplate_ReadAll: string = PrintTemplateURL + '/ReadAll';
export const PrintTemplate_ReadById: string = PrintTemplateURL + '/ReadById';
export const PrintTemplate_ReadByHospitalId: string = PrintTemplateURL + '/ReadByHospitalId';
//#endregion

//#region PatientBedAllocationMapping API
export const PatientBedAllocationMappingURL: string = HospitalBaseURL + '/PBAM';
export const PatientBedAllocationMapping_Create: string = PatientBedAllocationMappingURL + '/Create';
export const PatientBedAllocationMapping_Update: string = PatientBedAllocationMappingURL + '/Update';
export const PatientBedAllocationMapping_Delete: string = PatientBedAllocationMappingURL + '/Delete';
export const PatientBedAllocationMapping_ReadAll: string = PatientBedAllocationMappingURL + '/ReadAll';
export const PatientBedAllocationMapping_ReadById: string = PatientBedAllocationMappingURL + '/ReadById';
export const PatientBedAllocationMapping_ReadByHospitalId: string = PatientBedAllocationMappingURL + '/ReadByHospitalId';
export const PatientBedAllocationMapping_ReadByPatientId: string = PatientBedAllocationMappingURL + '/ReadByPatientId';
export const PatientBedAllocationMapping_ReadAllPaginated: string = PatientBedAllocationMappingURL + '/ReadAllPaginated';
export const PatientBedAllocationMapping_GetAdmittedDischargedSummary: string = PatientBedAllocationMappingURL + '/GetAdmittedDischargedSummary';
export const PatientBedAllocationMapping_GetTotalIPDPatient :string = PatientBedAllocationMappingURL + '/GetTotalIPDPatient';
export const PatientBedAllocationMapping_GetAllOccupiedPatients:string = PatientBedAllocationMappingURL + '/GetAllOccupiedPatients'
//#endregion

//#region PrintMaster API
export const PrintMasterURL: string = HospitalBaseURL + '/PM';
export const PrintMaster_ReadByMasterType: string = PrintMasterURL + '/ReadByMasterType';
//#endregion

//#region DepartmentMaster API
export const DepartmentMasterURL: string = HospitalBaseURL + '/DM';
export const DepartmentMaster_Create: string = DepartmentMasterURL + '/Create';
export const DepartmentMaster_Update: string = DepartmentMasterURL + '/Update';
export const DepartmentMaster_Delete: string = DepartmentMasterURL + '/Delete';
export const DepartmentMaster_ReadAll: string = DepartmentMasterURL + '/ReadAll';
export const DepartmentMaster_ReadById: string = DepartmentMasterURL + '/ReadById';
export const DepartmentMaster_ReadByHospitalId: string = DepartmentMasterURL + '/ReadByHospitalId';
export const DepartmentMaster_ReadByHospitalId_External: string = DepartmentMasterURL + '/ReadByHospitalId_External';
export const DepartmentMaster_ReadAllPaginated: string = DepartmentMasterURL + '/ReadAllPaginated';
export const DepartmentMaster_CreateBulk: string = DepartmentMasterURL + '/CreateBulk';
//#endregion

//#region  HMBackendDiscount API
export const HMBackendDiscountURL: string = HospitalBaseURL + '/HMBD';
export const HMBackendDiscount_Create : string = HMBackendDiscountURL +'/Create';
export const HMBackendDiscount_Update : string = HMBackendDiscountURL +'/Update';
export const HMBackendDiscount_Delete : string = HMBackendDiscountURL +'/Delete';
export const HMBackendDiscount_ReadById : string = HMBackendDiscountURL + '/ReadById';
export const HMBackendDiscount_ReadAll: string = HMBackendDiscountURL + '/ReadAll';
export const HMBackendDiscount_ReadByHospitalId : string = HMBackendDiscountURL +'/ReadByHospitalId';
export const HMBackendDiscount_ReadAllPaginated : string = HMBackendDiscountURL +'/ReadAllPaginated';
//#endregion

//#region PatientVitals API
export const PatientVitalsURL: string = HospitalBaseURL + '/PVL';
export const PatientVitals_Create: string = PatientVitalsURL + '/Create';
export const PatientVitals_Update: string = PatientVitalsURL + '/Update';
export const PatientVitals_Delete: string = PatientVitalsURL + '/Delete';
export const PatientVitals_ReadAll: string = PatientVitalsURL + '/ReadAll';
export const PatientVitals_ReadById: string = PatientVitalsURL + '/ReadById';
export const PatientVitals_ReadByHospitalId: string = PatientVitalsURL + '/ReadByHospitalId';
export const PatientVitals_ReadByPatientId: string = PatientVitalsURL + '/ReadByPatientId';
//#endregion

//#region Medicine API
export const MedicineURL:string = HospitalBaseURL + '/MED';
export const Medicine_Create:string = MedicineURL + '/Create';
export const Medicine_Update:string = MedicineURL + '/Update';
export const Medicine_Delete:string = MedicineURL + '/Delete';
export const Medicine_ReadByID:string = MedicineURL + '/ReadById';
export const Medicine_ReadByHospitalId:string = MedicineURL + '/ReadByHospitalId';
export const Medicine_CreateBulk:string = MedicineURL + '/CreateBulk';
//#endregion

//#region Menu Master
export const MenuMasterBaseURL: string = environment.apiURL;
export const MenuMaster: string = MenuMasterBaseURL + '/M';
export const MenuMasterURL :string  = MenuMaster + '/MM';
export const MenuMaster_create = MenuMasterURL + '/Create';
export const MenuMaster_update = MenuMasterURL + '/Update';
export const MenuMaster_readById = MenuMasterURL + '/ReadById';
export const MenuMaster_delete = MenuMasterURL + '/Delete';
export const MenuMaster_readBySoftwareId = MenuMasterURL + '/ReadBySoftwareId';
export const MenuMaster_readByUserId = MenuMasterURL + '/ReadByUserId';
export const MenuMaster_readAll = MenuMasterURL + '/ReadAll';
//#endregion

//#region PatientDepositTransaction
export const PatientDepositTransactiURL: string = HospitalBaseURL + '/PDT';
export const PatientDepositTransaction_Create = PatientDepositTransactiURL + '/Create';
export const PatientDepositTransaction_Update = PatientDepositTransactiURL + '/Update';
export const PatientDepositTransaction_Delete = PatientDepositTransactiURL + '/Delete';
export const PatientDepositTransaction_ReadAll = PatientDepositTransactiURL + '/ReadAll';
export const PatientDepositTransaction_ReadById = PatientDepositTransactiURL + '/ReadById';
export const PatientDepositTransaction_ReadByMasterId = PatientDepositTransactiURL + '/ReadByMasterId';
export const PatientDepositTransaction_AmountByPatientId = PatientDepositTransactiURL + '/AmountByPatientId';
//#endregion

//user hospital enquiry
export const PatientInquiryURL: string = HospitalBaseURL + '/PI';
export const PatientInquiry_Create = PatientInquiryURL + '/Create';
export const PatientInquiry_ReadById = PatientInquiryURL + '/ReadById';
export const PatientInquiry_Update = PatientInquiryURL + '/Update';
export const PatientInquiry_Delete = PatientInquiryURL + '/Delete';
export const PatientInquiry_ReadAll = PatientInquiryURL + '/ReadAll';
export const PatientInquiry_ReadRaisedBy = PatientInquiryURL + '/ReadRaisedBy';
export const PatientInquiry_ReadReceivedBy = PatientInquiryURL + '/ReadReceivedBy';
export const PatientInquiry_ReadByHospitalId = PatientInquiryURL + '/ReadByHospitalId';
export const PatientInquiry_ReadAllPaginated = PatientInquiryURL + '/ReadAllPaginated';